const styles = {
    secondHeader: {
        color: "#000000",
        fontSize: "14px",
        lineHeight: "18px",
        letterSpacing: "0.2px",
        fontFamily: "Roboto",
        paddingLeft: "0",
        paddingRight: "0",
        marginLeft: "0",
        marginRight: "0",
        marginTop: "19px"
    },
    address: {
        color: "#06844D",
        marginTop: "3px",
        fontFamily: "IBM Plex Sans",
        fontSize: "13px",
        lineHeight: "18px",
        paddingLeft: "0",
        paddingRight: "0",
        marginLeft: "0",
        marginRight: "0",
        fontWeight: "400"
    },
    name: {
        color: "#424F49",
        fontFamily: "IBM Plex Sans",
        fontSize: "13px",
        lineHeight: "18px",
        paddingLeft: "0",
        paddingRight: "0",
        marginLeft: "0",
        marginRight: "0",
        marginTop: "3px",
        marginBottom: "31px"
    },
    visitDate: {
        color: "#4E6D6F",
        fontFamily: "Roboto",
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "20px",
        marginBottom: "11px",
        marginLeft: "19px",
        marginTop:"24px",
        letterSpacing: "0.1px"
    },
    wrapper: {
        padding: "0",
        marginTop: "6px",
        marginLeft: "26px",
        marginRight: "26px",
        width: "86.2vw"
    }
}

export default styles;
